;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { StocklistSourceExpiryStatus } from '@qogita/canary-client/sellers'
import { differenceInMilliseconds } from 'date-fns'
import { getFormattedTimeUntilExpirationDate } from 'src/core/utils/get-formatted-time-until-expiration-date'

type ExpiresIn = {
  variant: 'red' | 'caution' | 'default'
  label: string
  tooltip?: string
}

export function getExpiresIn({
  status,
  expiresAt,
  now,
}: {
  status: StocklistSourceExpiryStatus
  expiresAt: string | null
  now: Date
}): ExpiresIn | null {
  if (status === 'error') {
    return {
      variant: 'red',
      label: 'Error',
      tooltip:
        'File upload failed. Your price list is no longer active. Please upload a new file.',
    }
  }
  if (status === 'expired') {
    return {
      variant: 'red',
      label: 'Expired',
      tooltip: expiresAt ? formatExpiresAt(expiresAt) : undefined,
    }
  }
  if (!expiresAt) return null

  const priceListExpiredAtInMilliseconds = differenceInMilliseconds(
    expiresAt,
    now,
  )

  return {
    variant: status === 'warning' ? 'caution' : 'default',
    label: getFormattedTimeUntilExpirationDate(
      priceListExpiredAtInMilliseconds,
    ),
    tooltip: formatExpiresAt(expiresAt),
  }
}

function formatExpiresAt(value: string | Date) {
  return new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    day: '2-digit',
    year: 'numeric',
    month: 'short',
    timeZoneName: 'short',
  }).format(typeof value === 'string' ? new Date(value) : value)
}
